import { Show, JSX, Accessor, } from 'solid-js';


interface FieldErrorMessageProps {
    errors: Accessor<Record<string, string | undefined>>;
    fieldKey: string | Accessor<string>;
}

interface FormStylingProps {
  children?: JSX.Element;
}

interface FormSelectLabelProps {
  children?: JSX.Element;
  for?: string;
  id?: string;
}

interface FormSelectProps {
    children?: JSX.Element;
    value: string;
    hasErrors?: boolean;
    id?: string;
    required?: boolean;
    onChange?: JSX.EventHandlerUnion<HTMLSelectElement, Event>;
    name?: string;
    'aria-labelledby'?: string;
    'aria-describedby'?: string;
    title?: string;
    autocomplete?: string;
}

interface FormInputProps {
    hasErrors?: boolean;
    required?: boolean;
    value?: string;
    onChange?: JSX.EventHandlerUnion<HTMLInputElement, Event>;
    placeholder?: string;
    name?: string;
    'aria-label'?: string;
    'aria-describedby'?: string;
    title?: string;
    autocomplete?: string;
    type?: string;  
}

export const FieldErrorMessage = (props: FieldErrorMessageProps): JSX.Element => {
    const fieldKey = () => typeof props.fieldKey === 'function' 
        ? props.fieldKey() 
        : props.fieldKey;
    
    return (
        <Show when={props.errors()[fieldKey()]}>
            <div 
                class="text-pink font-atos-regular text-[1.3rem] mb-[0.5rem] mt-[0.3rem]"
                innerHTML={props.errors()[fieldKey()]!} 
            />
        </Show>
    );
};

export const IconWrapper = (props: FormStylingProps) => {

    return(
        <div class="absolute right-[1.8rem] top-[0] bottom-[0] h-[1.8rem] pointer-events-none m-auto">
            {props.children}
        </div>
    );
};

export const FormSelectWrapper = (props: FormStylingProps) => {
     
    return(
        <div class="relative">{props.children}</div>
    );
};

export const FormSelectLabel = (props: FormSelectLabelProps) => {

    return(
        <label class="text-normal text-gray-dark font-atos-regular mt-[0.9rem] mb-[0.8rem] block">
            {props.children}
        </label>
    );
};

export const FormSelect = (props: FormSelectProps) => {

    return(
        <select 
            id={props.id}
            required={props.required}
            value={props.value || ''}
            onChange={props.onChange}
            name={props.name}
            aria-labelledby={props['aria-labelledby']}
            aria-describedby={props['aria-describedby']}
            title={props.title}
            autocomplete={props.autocomplete}
            classList={{
                'text-normal': true,
                'font-atos-regular': true,
                'rounded-[5px]': true,
                'p-[1rem]': true,
                'w-full': true,
                'cursor-pointer': true,
                'appearance-none': true,
                'border': true,
                
                'text-[#707070]': props.value === '',
                'text-black': props.value !== '',
                
                'border-pink': props.hasErrors,
                'border-[#707070]': !props.hasErrors,

            }}
        >
            {props.children}
        </select>
    );
};

export const FormInput = (props: FormInputProps) => {

    return (
        <input
            type={props.type || 'text'}
            required={props.required}
            value={props.value || ''}
            onChange={props.onChange}
            placeholder={props.placeholder}
            name={props.name}
            aria-label={props['aria-label']}
            aria-describedby={props['aria-describedby']}
            title={props.title}
            autocomplete={props.autocomplete}
            classList={{
                'w-full': true,
                'text-normal': true,
                'font-atos-regular': true,
                'rounded-[5px]': true,
                'p-[1rem]': true,
                'border': true,            

                'border-pink': props.hasErrors,
                'border-[#707070]': !props.hasErrors,
            }}
        />
    );
};
